import { VEHICLE_MODULE_PREFIX } from '../constants';
export const VEHICLE_ADMIN_CUSTOM_FIELD_VALIDATION_RECEIVED = `${VEHICLE_MODULE_PREFIX}_ADMIN_CUSTOM_FIELD_VALIDATION_RECEIVED`;
/**
 * Action creator used to create an action that contains information about
 * admin custom field validations that are received for a vehicle.
 * @param validations Current admin custom field validation object
 */
export const vehicleAdminFieldValidationsReceived = (validations) => {
    return {
        payload: validations,
        type: VEHICLE_ADMIN_CUSTOM_FIELD_VALIDATION_RECEIVED
    };
};
//# sourceMappingURL=vehicleAdminFieldValidationActions.js.map